<script>
  import { Link } from 'svelte-navigator';
  import Button from '../components/Button.svelte';
  import NavBar from '../components/NavBar.svelte';
  import LottieAnimation from '../components/LottieAnimation.svelte';
</script>

<section class="intro">
  <NavBar display_menu={false} hack={true}/>
  <div class="intro__main">
    <div class="intro__main--introtext">
      <div class="intro__main--title hide-for-mobile">
        <h1 class="slide-up-intro-title">FACE GARDEN</h1>
      </div>
      <div class="intro__main--title hide-for-desktop">
        <h1 class="slide-up">FACE</h1>
        <h1 class="slide-up">GARDEN</h1>
      </div>
      <div class="intro__main--subtitle">
        <p class="fadeIn">Interactive Facial Exercises</p>
      </div>
    </div>
    <div class="intro__main--bloomMobile hide-for-desktop">
      <LottieAnimation path="/lotties/title-flowers-mobile.json" />
    </div>
    <div class="intro__main--bloomDesktop hide-for-mobile">
      <LottieAnimation path="/lotties/title-flowers-desktop.json" />
    </div>
  </div>
  <div class="intro__footer">
    <Link to="/home" class="fadeIn">
      <Button buttonSize="btn--xlarge" buttonStyle="btn--primary--solid">
        LET'S GO
      </Button>
    </Link>
  </div>
</section>
